import React, {useState} from "react";
import {Input, RadioButtonField, RadioButtonLabel} from "./widgets/Styled";
import {FieldInputProps} from "react-final-form";

export interface RadioButtonProps {
    name: string;
    isChecked?: boolean;
    isDisabled?: boolean;
    label: string;
    id: string;
    isError?: boolean | string;
    rff?: FieldInputProps<number | string | null>;
    value: string | number;
    isTouched?: boolean;
    isFocused?: boolean;
}

const RadioButton: React.FC<RadioButtonProps> = (props: RadioButtonProps) => {
    const {
        isChecked = false,
        isDisabled = false,
        label,
        id,
        isTouched,
        isFocused = false,
        isError = false,
        rff,
        value,
        ...rest
    } = props;
    const isRFF = !!rff?.name;
    const error = isError && isTouched;
    const [checked, setChecked] = useState(isRFF ? undefined : isChecked);

    return (
        <RadioButtonField>
            <Input
                type="radio"
                checked={checked ?? isChecked}
                id={id}
                value={value}
                disabled={isDisabled}
                aria-labelledby={id}
                aria-checked="false"
                isError={error && !isFocused}
                {...rest}
                {...(!isRFF
                    ? {
                          onChange: (e: React.ChangeEvent<HTMLInputElement>): void => {
                              const target = e.target;
                              setChecked(target.checked);
                          },
                      }
                    : {...rff})}
            />
            <RadioButtonLabel htmlFor={id} disabled={isDisabled}>
                {label}
            </RadioButtonLabel>
        </RadioButtonField>
    );
};

export default RadioButton;
